module.exports = __webpack_public_path__ + "assets/active.ce0afaa31234a6839f6dff964c9c7f8b.svg";